<template>
  <div class="redirect-block">
    <h3 class="redirect-block__title">{{ $t('view.flow.block.redirect.title') }}</h3>
    <sel
      :label="$t('view.flow.block.redirect.selectTitle')"
      v-model="val.target"
      class="redirect-block__select"
      @input="setVars(); onInput()"
    >
      <optgroup v-for="group in this.$store.state.flowGroups" :key="group.id" :label="group.name">
        <option v-for="block in group.blocks" :key="block.id" :value="block.uuid">{{ block.name }}</option>
      </optgroup>
    </sel>

    <div class="redirect-block__vars">
      <sw-button
        v-model="val.passVariables"
        :label="$t('view.flow.block.redirect.variables')"
        @input="onInput"
        v-if="blockVariables && Object.keys(blockVariables).length"
      ></sw-button>

      <div class="redirect-block__vars-fields" v-if="val.passVariables">
        <div v-for="(field, k, i) in blockVariables" :key="i" class="redirect-block__vars-field">
          <in
            v-if="field.type === 'number' || field.type === 'string'"
            :label="k"
            v-model="val.variables[k]"
            @input="onInput"
          ></in>
          <sw-button v-else v-model="val.variables[k]" :label="k" @input="onInput"></sw-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      val: null
    }
  },
  props: ['value', 'blockId'],
  created () {
    this.val = this.value
  },
  methods: {
    onInput () {
      this.$emit('input', this.val)
      this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
      this.$store.commit('SET_EDITED', true)
    },

    setVars () {
      this.val.variables = {}
      for (let v in this.blockVariables) {
        let t = null
        if (v.type === 'string') t = ''
        else if (v.type === 'number') t = 0
        else if (v.type === 'boolean') t = true
        this.val.variables[v] = t
      }
    }
  },
  computed: {
    blockVariables: function () {
      const block = this.$store.getters.flowBlock(this.val.target)
      if (!block) return null
      return block.data.variables
    }
  }
}
</script>

<style lang="scss" scoped>
.redirect-block {
  @include flowElementShadow();
  width: 35%;
  background-color: white;
  border-radius: 7px;
  padding: 1px 14px 10px 14px;
  text-align: left;

  &__separator {
    margin-top: 20px;
  }

  &__title {
    margin: 9px 0 12px 0;
    text-align: left;
  }

  &__vars {
    margin-top: 7px;
  }

  &__vars-fields {
    @include alignedFlex(flex-start);
    flex-wrap: wrap;
  }

  &__vars-field {
    width: 200px;
    margin-top: 5px;
    margin-right: 10px;
  }
}
</style>
